import { Badge } from "../../../app/components/primitives/badge";
import { POLLARDS_PHONE } from "../portalContact";

// An item nothing prices online (the merchandise team quotes each one): the item page's buy box says so and how to ask,
// in place of a price, the options and Add to basket. A request form is the next phase.
export function QuotedToOrderNotice() {
  return (
    <div
      role="note"
      className="flex flex-col items-start gap-2 rounded-lg border bg-muted/30 p-6"
    >
      <Badge variant="neutral">Quoted to order</Badge>
      <p className="text-sm text-muted-foreground">
        Our merchandise team will price this product for you. Ask us for a quote
        on <span className="whitespace-nowrap">{POLLARDS_PHONE}</span>.
      </p>
    </div>
  );
}
